var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/babel-runtime/~/core-js/library/modules/_shared-key.js
// module id = 186
// module chunks = 1